module.exports = __webpack_public_path__ + "static/mreavesxlsannarri-020415006EmigreWebOnly-2481ad1bb6e2f99304adc08e7d7c2ef2.woff2";